import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { DependencyModel, DependencyRegistrableEntityModel } from '../models/dependencies';
import { ManagementEntityEventModel } from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class DependenciesRepository {
  constructor(private apiService: ApiService) {}

  public getDependenciesForISF(isfId: number): Observable<DependencyModel[]> {
    return this.apiService.get<DependencyModel[]>(`${environment.url.prefixCustoms}v2/isf/${isfId}/dependencies`);
  }

  public getDependenciesForES(esId: number): Observable<DependencyModel[]> {
    return this.apiService.get<DependencyModel[]>(`${environment.url.prefixCustoms}v2/entry-summaries/${esId}/dependencies`);
  }

  public getDependenciesForCompany(companyId: number): Observable<DependencyModel[]> {
    return this.apiService.get<DependencyModel[]>(`${environment.url.companies}${companyId}/dependencies`);
  }

  public registerImporterForEs(esId: number, entity: DependencyRegistrableEntityModel): Observable<never> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/entry-summaries/${esId}/registered-importers`, entity);
  }

  public registerConsigneeForEs(esId: number, entity: DependencyRegistrableEntityModel): Observable<never> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/entry-summaries/${esId}/registered-consignees`, entity);
  }

  public registerManufacturerForEs(esId: number, entity: DependencyRegistrableEntityModel): Observable<never> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/entry-summaries/${esId}/registered-manufacturers`, entity);
  }

  public registerImporterForCompany(companyId: number, entity: DependencyRegistrableEntityModel): Observable<never> {
    return this.apiService.post(`${environment.url.companies}${companyId}/registered-importers`, entity);
  }

  public getDependencyEvents(dependencyId: number, isShowLoader: boolean = true): Observable<ManagementEntityEventModel[]> {
    return this.apiService.get<ManagementEntityEventModel[]>(
      `${environment.url.prefixCustoms}v2/dependencies/${dependencyId}/events`,
      null,
      {
        isShowLoader,
        isUsed: true,
      },
    );
  }
}
